import { cosemApi } from '@services/providers/cosem';
import { StateCode, StateCodeToCreate, StateCodeToUpdate } from './state-codes.types';
import { ApiPaginationResponse, ApiResponse } from '@services/providers/cosem.types';

const stateCodesApi = cosemApi.injectEndpoints({
    endpoints: (build) => ({
        getPaginatedStateCodes: build.mutation<
            ApiPaginationResponse<StateCode>,
            { limit?: number; page?: number; search?: string; orderBy?: string }
        >({
            query: ({ limit = 10, page = 1, search, orderBy }) => {
                return {
                    url: `/member/state-codes/paginated`,
                    method: 'GET',
                    params: { limit, page, search: search ?? '', orderBy: orderBy ?? '' }
                };
            },
            transformResponse: (response: ApiPaginationResponse<StateCode>) => response
        }),
        getArchivedPaginatedStateCodes: build.mutation<
            ApiPaginationResponse<StateCode>,
            { limit?: number; page?: number; search?: string; orderBy?: string }
        >({
            query: ({ limit = 10, page = 1, search, orderBy }) => {
                return {
                    url: `/member/state-codes/archived/paginated`,
                    method: 'GET',
                    params: { limit, page, search: search ?? '', orderBy: orderBy ?? '' }
                };
            },
            transformResponse: (response: ApiPaginationResponse<StateCode>) => response
        }),
        updateStateCode: build.mutation<ApiResponse<StateCode>, StateCodeToUpdate>({
            query: (stateCode: StateCodeToUpdate) => {
                return {
                    url: `/member/state-codes/${stateCode.id}`,
                    method: 'PUT',
                    body: stateCode
                };
            },
            transformResponse: (response: ApiResponse<StateCode>) => response
        }),
        createStateCode: build.mutation<ApiResponse<StateCode>, StateCodeToCreate>({
            query: (stateCode: StateCodeToCreate) => {
                return {
                    url: `/member/state-codes`,
                    method: 'POST',
                    body: stateCode
                };
            },
            transformResponse: (response: ApiResponse<StateCode>) => response
        }),
        deleteStateCode: build.mutation<ApiResponse<StateCode>, { id: string }>({
            query: ({ id }) => {
                return {
                    url: `/member/state-codes/${id}`,
                    method: 'DELETE'
                };
            },
            transformResponse: (response: ApiResponse<StateCode>) => response
        }),
        toggleArchiveStateCode: build.mutation<ApiResponse<StateCode>, { id: string|number, archived: boolean }>({
            query: ({ id, archived }) => {
                return { 
                    url: `/member/state-codes/${id}/archive`, 
                    method: 'PUT',
                    body: { archived }
                };
            },
            transformResponse: (response: ApiResponse<StateCode>) => response
        })
    })
});

export const {
    useGetPaginatedStateCodesMutation,
    useGetArchivedPaginatedStateCodesMutation,
    useUpdateStateCodeMutation,
    useCreateStateCodeMutation,
    useDeleteStateCodeMutation,
    useToggleArchiveStateCodeMutation
} = stateCodesApi;
